<template>
    <div>
        <div class="page-filter-box">
            <el-row :gutter="20">
                <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4">
                    <el-select v-model="params.objectType" placeholder="请选择" size="small">
                        <el-option label="不限制跟踪对象类型" value=""></el-option>
                        <el-option label="仅看跟踪对象是乐迷的" :value="7"></el-option>
                        <el-option label="仅看跟踪对象是场地的" :value="2"></el-option>
                        <el-option label="仅看跟踪对象是艺人的" :value="1"></el-option>
                        <el-option label="仅看跟踪对象是厂牌的" :value="3"></el-option>
                        <el-option label="仅看跟踪对象是演出的" :value="4"></el-option>
                        <el-option label="仅看跟踪对象是巡演的" :value="5"></el-option>
                        <el-option label="仅看其他跟踪对象" :value="99"></el-option>
                    </el-select>
                </el-col>
                <el-col v-if="params.objectType != 99" :xs="24" :sm="12" :md="8" :lg="8" :xl="4">
                    <el-input v-model="params.queryValue" class="input-with-select" size="small">
                        <el-select v-model="params.queryType" slot="prepend" placeholder="请选择">
                            <el-option label="按ID查询" :value="1"></el-option>
                            <el-option label="按名称查询" :value="2"></el-option>
                        </el-select>
                    </el-input>
                </el-col>
                <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4">
                    <el-select v-model="params.styleId" placeholder="请选择" size="small">
                        <el-option label="不限制风格分类" value=""></el-option>
                        <el-option v-for="(item, index) in styleTagList" :key="index" :label="`仅看${item.name}的`" :value="item.id"></el-option>
                    </el-select>
                </el-col>
                <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4">
                    <el-select v-model="params.sort" placeholder="请选择" size="small">
                        <el-option label="优先展示最新日期的" :value="9"></el-option>
                        <el-option label="优先展示PV最高的" :value="1"></el-option>
                        <el-option label="优先展示UV最高的" :value="2"></el-option>
                        <el-option label="优先展示注册人数最高的" :value="3"></el-option>
                        <el-option label="优先展示订单数最高的" :value="4"></el-option>
                        <el-option label="优先展示下单人数最高的" :value="5"></el-option>
                        <el-option label="优先展示销售额最高的" :value="6"></el-option>
                        <el-option label="优先展示注册转化率最高的" :value="7"></el-option>
                        <el-option label="优先展示下单转化率最高的" :value="8"></el-option>
                    </el-select>
                </el-col>
                <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4" class="page-filter-btns">
                    <el-button type="primary" icon="el-icon-search" @click="search" size="small">查询</el-button>
                    <el-button type="default" icon="el-icon-refresh" @click="reset" size="small">重置</el-button>
                </el-col>
            </el-row>
        </div>
        <div class="page-btns-box">
            <el-button v-if="$utils.have('/report/channel/channelDataDownload') && dataList && dataList.length > 0" type="primary" icon="el-icon-download" size="small" @click="download" :loading="downLoading">导出</el-button>
        </div>
        <div class="page-list-box">
            <el-table
                :data="dataList"
                border
                style="width: 100%"
                v-loading="listLoading"
                size="small"
                stripe
            >
                <el-table-column prop="channelName" label="渠道名称" min-width="100" show-overflow-tooltip>
                </el-table-column>
                <el-table-column prop="objectType" label="对象类型">
                    <template slot-scope="scope">
                        {{objectType[scope.row.objectType]}}
                    </template>
                </el-table-column>
                <el-table-column prop="objectId" label="对象ID">
                </el-table-column>
                <el-table-column prop="styleName" label="风格分类" min-width="100" show-overflow-tooltip>
                </el-table-column>
                <el-table-column prop="pv" label="PV">
                </el-table-column>
                <el-table-column prop="uv" label="UV">
                </el-table-column>
                <el-table-column prop="registerNum" label="注册人数">
                </el-table-column>
                <el-table-column prop="orderNum" label="订单数">
                </el-table-column>
                <el-table-column prop="orderUser" label="下单人数">
                </el-table-column>
                <el-table-column prop="orderAmount" label="销售额">
                </el-table-column>
                <el-table-column prop="registerCr" label="注册转化率" min-width="90">
                    <template slot-scope="scope">
                        {{(scope.row.registerCr * 100).toFixed(1)}}%
                    </template>
                </el-table-column>
                <el-table-column prop="orderCr" label="下单转化率" min-width="90">
                    <template slot-scope="scope">
                        {{(scope.row.orderCr * 100).toFixed(1)}}%
                    </template>
                </el-table-column>
                <el-table-column fixed="right" label="操作" width="100">
                    <template slot-scope="scope">
                        <el-button
                            v-if="$utils.have('/report/channel/channelTimeList')"
                            type="text"
                            size="small"
                            icon="el-icon-view"
                            @click="view(scope.row)"
                            >日期明细</el-button
                        >
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div v-if="data" class="page-pagination-box">
            <el-pagination
                background
                @size-change="handleSizeChange"
                @current-change="getDataList"
                :current-page.sync="params.pageNo"
                :page-sizes="$pageSizes"
                :page-size.sync="params.pageSize"
                layout="total, sizes, prev, pager, next"
                :total="data.totalCount || 0">
            </el-pagination>
        </div>
    </div>
</template>
<script>
import {fetchStyleList,downloadFileTmp} from '@/assets/js/commonApi';
const defaultParams = {
    channelId: "",
    pageNo:1,
    queryType: 1,
    queryValue: "",
    objectType: "",
    styleId: "",
    sort:9,
    startTime:'',
    endTime:'',
    trackPath:"",
    channelName:"",
}
export default {
    props:{
        id: {
            type: [Number,String]
        }
    },
    data(){
        return{
            data: null,
            dataList: null,
            params:{
                ...defaultParams,
                pageNo:parseInt(this.$route.query.pageNo || 1),
                pageSize: parseInt(this.$route.query.pageSize || this.$pageSizes[0]),
                queryType:parseInt(this.$route.query.queryType || 1),
                queryValue: this.$route.query.queryValue || "",
                objectType:parseInt(this.$route.query.objectType) || "",
                styleId:parseInt(this.$route.query.styleId) || "",
                sort:parseInt(this.$route.query.sort || 9),
                startTime: this.$route.query.startTime,
                endTime: this.$route.query.endTime,
                trackPath: this.$route.query.trackPath || "",
                channelName: this.$route.query.channelName || '',
            },
            listLoading: true,
            downLoading: false,
            styleTagList: [], //风格列表集合
        }
    },
    computed:{
        objectType(){
            return {
                1: '艺人',
                2: '场地',
                3: '厂牌',
                4: '演出',
                5: '巡演',
                7: '乐迷',
                99: '其他'
            }
        }
    },
    mounted() {
        this.params.channelId = this.id;
        this.getStyleTagList();
        this.getDataList();
    },
    methods:{
        //获取风格列表
        async getStyleTagList(){
            const res = await fetchStyleList();
            const {state, result} = res.data;
            if( state && state == 1 ){
                this.styleTagList = result;
            }    
        },
        //获取列表
        getDataList() {
            this.listLoading = true;
            this.params = {
                ...this.params,
                queryValue: this.params.objectType !== 99 ? this.params.queryValue : ''
            }
            this.$request({
                url: "/report/channel/channelDataList",
                method: "POST",
                data: {
                    ...this.params,
                },
            })
			.then((res) => {
				const { state, msg, result } = res.data;
				if ( state == 1 && result) {
					this.data = result;
					this.dataList = result.result || [];
				} else {
					this.$message.error(msg || "请求失败");
				}
			})
			.catch(() => {
				this.$message.error("请求错误");
			})
			.finally(() => {
				this.listLoading = false;
			});
        },
        //选择pageSize
        handleSizeChange(e) {
            this.params.pageNo = 1;
            this.params.pageSize = e;
            this.getDataList();
        },
        //搜索
        search() {
            this.params.pageNo = 1;
            this.getDataList();
        },
        //重置搜索
        reset() {
            this.params = {
                ...defaultParams,
                pageSize: this.params.pageSize,
                startTime: this.params.startTime,
                endTime: this.params.endTime,
                channelId: this.params.channelId,
            };
            this.getDataList();
        },
        //导出
        async download(){
            let filePath;
            this.downLoading = true;
            const res = await this.$request({
                url:'/report/channel/channelDataDownload',
                method: 'post',
                data: {
                    ...this.params,
                },
            })
                .catch(err => {
                    this.$message({message: err.message, type: 'error'});
                })
            const{state,msg,result} = res.data;
            if(state == 1 && result){
                filePath = result.url;
            }else{
                this.downLoading = false;
                return this.$message.error(msg || '下载失败');
            }   
            const _fileName = `${this.dataList[0].channelName}${ this.params.objectType && '-'+this.objectType[this.params.objectType]}-${this.id}-跟踪数据`
            await downloadFileTmp(filePath,_fileName+'.'+this.$utils.getFileType(filePath));
            this.downLoading = false;
        },
        //日期明细
        view(item){
            this.$router.push({
                path: `/report/channel/channelReport/channelTimeList/${this.id}/${item.objectId}`,
                query: {
                    redirect: this.$utils.objArgs(
                        this.$router.currentRoute.path,
                        {
                            ...this.params,
                        }
                    ),
                    ...this.params,
                    objectType: item.objectType
                },
            });
        }
    }
}
</script>

<style lang="scss" scoped>

</style>